module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/basketball-cd45168277d9134c6584dcb12d9cc359.svg";